import * as React from 'react';
import { ImageField, Show, ShowProps, SimpleShowLayout, TextField } from 'react-admin';

export const ProductCategoryShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<TextField source="name" label="NAME"/>
				{/*<TextField source="description" label="DESCRIPTION"/>*/}
				<ImageField source="imageUrl" label="IMAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
